export class FileDownloadHelper {
  public static downloadBlobAs(blob: Blob, fileName: string): void {
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');

    try {
      anchor.href = objectUrl;
      anchor.download = fileName;
      anchor.style.display = 'none';

      document.body.appendChild(anchor);
      anchor.click();
    } finally {
      anchor.remove();
      URL.revokeObjectURL(objectUrl);
    }
  }

  public static base64ToBlob(
    base64Content: string,
    contentType = 'application/octet-stream'
  ): Blob {
    const binaryContent = atob(base64Content);
    const bytes = Uint8Array.from(
      binaryContent,
      character => character.charCodeAt(0)
    );

    return new Blob([bytes], { type: contentType });
  }

  public static downloadBase64As(
    base64Content: string,
    fileName: string,
    contentType = 'application/octet-stream'
  ): void {
    const blob = this.base64ToBlob(base64Content, contentType);
    this.downloadBlobAs(blob, fileName);
  }
}
